import { useSettings } from '../contexts/SettingsContext';

export const useTradeDefaults = () => {
  const { settings } = useSettings();

  const getDefaultTradeValues = () => {
    const now = new Date();
    return {
      tradeDate: now.toISOString().split('T')[0],
      tradeTime: now.toTimeString().split(' ')[0].slice(0, 5),
      positionSize: settings.defaultPositionSize || 10,
      currency: settings.defaultCurrency || '$',
      tags: settings.defaultTags || [],
      status: 'ANALYSIS',
      leverage: 1,
      rating: 3,
    };
  };

  return { getDefaultTradeValues, settings };
};